
    import Vue from "vue";
    import { Prop, Watch, Component } from "vue-property-decorator";
    import * as Provincias from '@lib/Geograficos/Provincias';
import { Provincia } from '@lib/Geograficos/Provincias';
import { Wait } from '@/__env/ext';

    @Component( {
        name: "Componente",
        props: {},
        components: {}
    } )
    export default class Componente extends Vue {

        @Prop( { type: Boolean } ) public disabled: boolean;
        @Prop( { type: Boolean } ) public readonly: boolean;

        @Prop( { type: String } )
        public value: string;

        @Watch( 'value', { immediate: true } )
        onIndex() {
            this.Selected = this.value;
            this.Busqueda = this.value;
        }

        constructor() {
            super();
        }

        public Items: Provincias.Provincia[] = [];

        public Busqueda: string = '';
        @Watch( 'Busqueda' )
        public async Buscar() {

            if ( this.Busqueda === this.Selected )
                return;

            if ( this.Estado === 'cargando' )
                return;

            let bb = this.Busqueda;
            await Wait( 600 );
            if ( bb == this.Busqueda )
            {
                this.Estado = 'cargando';
                let e = await Provincias.Provincia.find( { q: this.Busqueda } );
                this.Items = e.Items;
                this.Estado = 'ok';
            }
 
        }




        public selected: string | null = null;
        public get Selected(): string | Provincia | null {
            return this.selected;
        }
        public set Selected( x: string | Provincia | null ) {

            if ( x instanceof Provincia ) {
                this.selected = x?.Nombre;
                this.$emit( 'provincia', x );
            }
            else
                this.selected = x;

            this.$emit( 'input', this.Selected );
        }

        public async onLostFocus( event: any ) {

        }

        public Estado: 'cargando' | 'ok' | 'error' | 'vacio' | 'iniciado' = 'iniciado';
    }
